import { render, staticRenderFns } from "./SellerPage.vue?vue&type=template&id=27057d52"
import script from "./SellerPage.vue?vue&type=script&lang=js"
export * from "./SellerPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports